// @flow
import { generateSchema } from "src/utils/schemaUtils";
// $FlowFixMe
export default generateSchema(
  [{ name: "etiologyLocations" }, { name: "etiologyPatients" }],
  {}
);
